import { IBusiness } from "@/types/business-types";
import { prefix } from ".";
import { handleNameDisplay } from "@/utils";
import Skeleton from "../Skeleton";
import { Sticky } from 'react-vant';
import { TFunction } from "i18next";
import BackIcon from "../svg/BackIcon";

interface IBusinessProps {
  loading: boolean;
  business: IBusiness;
  t: TFunction<"common", undefined>;
  showBtn?: boolean;
  onBack?: () => void;
}

const Business: React.FC<IBusinessProps> = (props) => {
  const { loading, business, showBtn = false, t, onBack } = props;
  const businessName = business.businessName;

  return (
    <Sticky>
      <div className={`${prefix}`}>
        <Skeleton
          loading={loading}
          avatar
          row={1}
          rowWidth={['100%']}
        />
        {
          !loading &&
          <div className={`${prefix}-content`}>
            <div className={`${prefix}-title`}>{handleNameDisplay(businessName)}</div>
            <div className={`${prefix}-name`}>{businessName}</div>
          </div>
        }
        {
          showBtn &&
          <div className={`${prefix}-btn`} onClick={onBack ? onBack : () => {}}>
            <BackIcon className={`${prefix}-btn-icon`} />
            <span className={`${prefix}-btn-text`}>{t('back')}</span>
          </div>
        }
      </div>
    </Sticky>
  )
};

export default Business;